import type {
  Buergschaftsauftrag,
  BuergschaftsauftragMitteilungDetails,
} from '@/types/Buergschaftsauftrag';
import { SharedBuergschaftsauftragService } from '@/shared/api/services/buergschaftsauftrag.ts';

export class BuergschaftsauftragService extends SharedBuergschaftsauftragService {
  async storniereBuergschaftsauftrag(id: number | string): Promise<Buergschaftsauftrag> {
    return this.httpClient.post(`${this.baseUrl}/${id}/stornierung`);
  }

  async holeBuergschaftsauftragMitteilungDetails(
    id: number,
  ): Promise<BuergschaftsauftragMitteilungDetails> {
    return this.httpClient.get(`${this.baseUrl}/${id}/mitteilungdetails`);
  }
}
